import { Selector } from "@ngxs/store";
import { ApplicationState, ApplicationStateModel } from "./application.state";

export class ApplicationGetterState {
  @Selector([ApplicationState])
  static getSideMenuOpened(state: ApplicationStateModel) {
    return state.sideMenuOpened;
  }
}